export enum UiMoleculeMediaType {
  IMAGE = 'image',
  ANIMATION = 'animation',
}
